export const CHANGE = 'change'
export const PERCENTAGE_CHANGE = 'percentage_change'
export const LAST_PERIOD = 'last_period'
